import { Menu } from './menu.model';

export const horizontalMenuItems = [ 
    new Menu (20, 'Properties', null, null, null, null, null, null, true, 0, false, false),
    new Menu (21, 'All Available', null, null, '/available',null, null, null, false, 20, false, false),
    new Menu (22, 'Auctions', null, null, '/auction',null, null, null, false, 20, false, false),
    new Menu (23, 'Call For Offers', null, null, '/cfo',null, null, null, false, 20, false, false), 
    new Menu (24, 'Traditional Listings', null, null, '/tl',null, null, null, false, 20, false, false),
    //new Menu (25, 'Make Offer / Buy Now ', null, null, '/mobn',null, null, null, false, 20, false, false), 
    new Menu (26, 'Sold', null, null, '/sold', null, null, null, false, 20, false, false),
    new Menu (30, 'About Us', null, null, '/about', null, null, null, false, 0, false, false),
    new Menu (40, 'Contact', null, null, '/contact', null, null, null, false, 0, false, false),  
    new Menu (50, 'Register', null, null, '/register', null, null, null, false, 0, false, false), 
    new Menu (60, 'Login', null, null, '/login', null, null, null, false, 0, false, true),
    new Menu (70, 'Account', null, null, '/account', null, null, null, false, 0, true, false),
    new Menu (80, 'Logout', null, null, '/login', {logout:true}, null, null, false, 0, false, true),
]

export const verticalMenuItems = [ 
    new Menu (20, 'Properties', null, null, null, null, null, null, true, 0, false, false),
    new Menu (21, 'All Available', null, null, '/available',null, null, null, false, 20, false, false),
    new Menu (22, 'Auctions', null, null, '/auction',null, null, null, false, 20, false, false),
    new Menu (23, 'Call For Offers', null, null, '/cfo',null, null, null, false, 20, false, false), 
    new Menu (24, 'Traditional Listings', null, null, '/tl',null, null, null, false, 20, false, false),
    //new Menu (25, 'Make Offer / Buy Now ', null, null, '/mobn',null, null, null, false, 20, false, false), 
    new Menu (26, 'Sold', null, null, '/sold', null, null, null, false, 20, false, false),
    new Menu (30, 'About Us', null, null, '/about', null, null, null, false, 0, false, false),
    new Menu (40, 'Contact', null, null, '/contact', null, null, null, false, 0, false, false),  
    new Menu (50, 'Register', null, null, '/register', null, null, null, false, 0, false, false), 
    new Menu (60, 'Login', null, null, '/login', null, null, null, false, 0, false, false),
    new Menu (70, 'Account', null, null, '/account', null, null, null, false, 0, true, false),
    new Menu (80, 'Logout', null, null, '/login', {logout:true}, null, null, false, 0, false, false),
]

export const shareMenuItems = [ 
    new Menu (20, 'Share', 'share', false, null, null, null, null, true, 0, false, false),
    new Menu (21, 'Email', 'email', false, null, null, null, null, false, 20, false, false), 
    new Menu (22, 'Facebook', 'facebook', false, null, null, null, null, false, 20, false, false),
    new Menu (23, 'X', 'x-icon', true, 'x', null, null, null, false, 20, false, false),
    new Menu (24, 'LinkedIn', 'linkedin-icon', true, null, null, null, null, false, 20, false, false),
]